import { GET_SETTINGS_LIST_SUCCESS } from 'core/modules/settings/actions';
import { initialState } from 'core/modules/initialState';

export default function settings(state = initialState.settings, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case GET_SETTINGS_LIST_SUCCESS: {
      return {
        ...state,
        list: payload.list,
      };
    }
    default: {
      return state;
    }
  }
}
